// extracted by mini-css-extract-plugin
export default {"MainCont":"Oven_MainCont__2VmGs","RightCont":"Oven_RightCont__+0iKy"};